import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ReactSVG } from "react-svg";
import { XMarkIcon } from "@heroicons/react/24/solid";

import ClinicalsFeatureCard from "./ClinicalsFeatureCard";
import { setPatientsQueryParams } from "../../redux/modules/patient/actions";
import { buildPatientSearchQueryParams } from "../../helpers/functions";

const Clinicals = () => {
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Clinical Services and Interventions are both entered from a patient record,
  // so routing through Patients first mirrors the existing per-patient workflows.
  const goToPatients = (rawSearch = "") => {
    dispatch(setPatientsQueryParams(buildPatientSearchQueryParams(rawSearch)));
    navigate("/patients");
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    goToPatients(searchValue);
  };

  return (
    <div
      className="relative flex min-h-full flex-col bg-cover bg-top bg-no-repeat"
      style={{ backgroundImage: "url(/images/clinicals-hero.png)" }}
    >
      <form
        onSubmit={handleSearchSubmit}
        className="mx-auto mt-16 w-full max-w-[1000px] px-5"
      >
        <div className="flex h-[100px] items-center gap-2 rounded-full border border-gray-200 bg-white px-[30px] shadow-sm">
          <ReactSVG src="/icons/search.svg" className="h-5 w-5 shrink-0" />
          <input
            type="text"
            name="clinicalsSearch"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="Health Card, Patient Name, DOB (YYYYMMDD), Phone number"
            className="w-full border-0 bg-transparent text-lg text-gray-700 placeholder:text-gray-700 focus:outline-none focus:ring-0"
          />
          {!!searchValue && (
            <XMarkIcon
              className="h-6 w-6 shrink-0 cursor-pointer text-teal-300"
              onClick={() => setSearchValue("")}
            />
          )}
        </div>
      </form>

      <div className="mt-16 flex-1 rounded-t-[100px] bg-white/50 px-5 py-16 sm:px-10">
        <div className="mx-auto grid max-w-[1880px] grid-cols-1 gap-[30px] sm:grid-cols-2 xl:grid-cols-4">
          <ClinicalsFeatureCard
            title="Clinical Services"
            buttonText="Coming Soon"
            disabled
            icon={<img src="/icons/clinicals-clinical-services.svg" alt="" />}
          />
          <ClinicalsFeatureCard
            title="Interventions"
            buttonText="Manage Interventions"
            onButtonClick={() => goToPatients()}
            icon={<img src="/icons/clinicals-interventions.svg" alt="" />}
          />
          <ClinicalsFeatureCard
            title="Medical Summary"
            buttonText="Coming Soon"
            disabled
            icon={<img src="/icons/clinicals-medical-summary.svg" alt="" />}
          />
          <ClinicalsFeatureCard
            title="Education"
            buttonText="Coming Soon"
            disabled
            icon={
              <>
                <div className="absolute inset-[38.26%_60.59%_17.95%_23.08%]">
                  <img
                    src="/icons/clinicals-education-1.svg"
                    alt=""
                    className="absolute inset-[-4.39%_-11.77%] block h-full w-full"
                  />
                </div>
                <div className="absolute inset-[24.02%_12.82%_17.96%_57.93%]">
                  <img
                    src="/icons/clinicals-education-2.svg"
                    alt=""
                    className="absolute inset-[-3.32%_-6.57%] block h-full w-full"
                  />
                </div>
                <div className="absolute inset-[17.95%_44.18%_17.95%_39.48%]">
                  <img
                    src="/icons/clinicals-education-3.svg"
                    alt=""
                    className="absolute inset-[-3%_-11.77%] block h-full w-full"
                  />
                </div>
              </>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default Clinicals;
